(function () {
  'use strict';

  const CONFIG = {
    stickyBar:      '#sticky-atc-bar',
    stickySelect:   '#sticky-atc-variant-select',
    stickyBtn:      '#sticky-atc-btn',
    currentPriceEl: '#sticky-current-price',
    stickyImage:    '#sticky-atc-image',
    comparePriceEl: '#sticky-compare-price',
    mainAtcBtn:     'form[action="/cart/add"] [type="submit"]',
    currencySymbol: '$',
  };

  const stickyBar        = document.querySelector(CONFIG.stickyBar);
  const stickySelect     = document.querySelector(CONFIG.stickySelect);
  const stickyBtn        = document.querySelector(CONFIG.stickyBtn);
  const stickyImage      = document.querySelector(CONFIG.stickyImage);
  const currentPriceEl   = document.querySelector(CONFIG.currentPriceEl);
  const comparePriceEl   = document.querySelector(CONFIG.comparePriceEl);
  const variantSelection = document.querySelector('[data-variant-selection]');

  if (!stickyBar || !stickySelect) {
    return;
  }
  (function checkSingleVariant() {
  const data = getProductJSON(); // 注意：此时 getProductJSON 还未定义，见下方说明
  if (!data) return;
  if (data.variants && data.variants.length === 1) {
    const onlyVariant = data.variants[0];
    // public_title 为 null 或 'Default Title' 均视为单变体
    if (!onlyVariant.public_title || onlyVariant.public_title === 'Default Title') {
      if (stickySelect) stickySelect.style.display = 'none';
    }
  }
})();
  let barVisible            = false;
  let lastStickyTriggerTime = 0;
  let lastStickyVariantId   = '';
  const SYNC_COOLDOWN       = 300;

  function isCoolingDown() {
    return Date.now() - lastStickyTriggerTime < SYNC_COOLDOWN;
  }
  function showBar(show) {
    if (barVisible === show) return;
    barVisible = show;
    stickyBar.style.display = show ? 'flex' : 'none';
  }

  function formatPrice(cents) {
    if (cents == null || isNaN(cents)) return '';
    return CONFIG.currencySymbol + (cents / 100).toFixed(2);
  }
  function updateStickyImage(option) {
    if (!stickyImage || !option) return;
    const src = option.dataset.image;
    const alt = option.dataset.imageAlt || '';
    if (src) {
      stickyImage.src = src;
      stickyImage.alt = alt;
    }
  }
  

  function updateStickyState(option) {
    if (!option) return;
    const available    = option.dataset.available === 'true';
    const price        = parseInt(option.dataset.price, 10);
    const comparePrice = parseInt(option.dataset.comparePrice, 10);
    const isSale       = !isNaN(comparePrice) && comparePrice > price;

    if (stickyBtn) {
      stickyBtn.disabled    = !available;
      stickyBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
    if (currentPriceEl) {
      currentPriceEl.textContent = formatPrice(price);
      currentPriceEl.classList.toggle('is-sale', isSale);
    }
    if (comparePriceEl) {
      comparePriceEl.textContent   = isSale ? formatPrice(comparePrice) : '';
      comparePriceEl.style.display = isSale ? 'inline' : 'none';
    }
    updateStickyImage(option);
  }
  // ShopifyAnalytics.meta.product variant 结构：{ id, price, public_title, sku }（无 options 数组）
  function getProductJSON() {
    if (window.ShopifyAnalytics?.meta?.product) {
      return window.ShopifyAnalytics.meta.product;
    }
    const el = document.querySelector(
      '[data-product-json], ' +
      '#ProductJson-product-template, ' +
      'script[type="application/json"][data-product-id]'
    );
    try { return el ? JSON.parse(el.textContent) : null; } catch { return null; }
  }

  // variant 无 options 数组，用 public_title.split(' / ') 解析
  function syncThemeOptionUI(variantId) {
    const data = getProductJSON();
    if (!data) return;

    const variant = data.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    const options = variant.options
      ?? variant.public_title?.split(' / ')
      ?? [];

    if (!options.length) return;

    document.querySelectorAll('[data-variant-option]').forEach(group => {
      const optionIndex = parseInt(group.dataset.variantOptionIndex, 10);
      const targetValue = options[optionIndex];
      if (targetValue == null) return;
      group.querySelectorAll('input[data-variant-option-value]').forEach(radio => {
        radio.checked = (radio.value === targetValue);
      });
    });
  }

  // 主页面 → sticky
  function syncFromMain(newVal) {
    if (isCoolingDown()) return;
    if (!newVal || newVal === 'not-selected' || newVal === stickySelect.value) return;
    stickySelect.value  = newVal;
    lastStickyVariantId = newVal;
    updateStickyState(stickySelect.options[stickySelect.selectedIndex]);
  }

  // MutationObserver 监听 variant-selection 属性变化
  if (variantSelection) {
    new MutationObserver(mutations => {
      mutations.forEach(m => {
        if (m.attributeName !== 'variant') return;
        syncFromMain(variantSelection.getAttribute('variant'));
      });
    }).observe(variantSelection, { attributes: true, attributeFilter: ['variant'] });
  }

  // change 事件兜底（注意用 e.target，不是 this）
  document.addEventListener('change', function (e) {
    if (isCoolingDown()) return;
    const t = e.target;
    if (t === stickySelect) return;
    if (t.matches('select[name="id"]') || t.matches('input[name="id"]')) {
      syncFromMain(t.value);
    }
  });

  // 轮询兜底
  (function () {
    const getVal = () =>
      variantSelection?.getAttribute('variant') ||
      document.querySelector('input[name="id"][type="hidden"]')?.value ||
      document.querySelector('select[name="id"]')?.value || '';

    let lastVal = getVal();
    setInterval(() => {
      if (isCoolingDown()) return;
      const cur = getVal();
      if (cur && cur !== 'not-selected' && cur !== lastVal) {
        lastVal = cur;
        syncFromMain(cur);
      }
    }, 200);
  })();

  // sticky → 主页面
  stickySelect.addEventListener('change', function () {
    const variantId = this.value;
    if (!variantId || variantId === 'not-selected') return;
    if (variantId === lastStickyVariantId) return;

    lastStickyVariantId   = variantId;
    lastStickyTriggerTime = Date.now();
    syncThemeOptionUI(variantId);

    // 触发主题内部逻辑（价格/图片/库存）主题会在内部重置 radio，所以需要延迟再设置一次
    if (variantSelection) {
      variantSelection.setAttribute('variant', variantId);
    }
    setTimeout(() => syncThemeOptionUI(variantId), 50);
    setTimeout(() => syncThemeOptionUI(variantId), 150);
    const hiddenSelect = document.querySelector('select[name="id"]');
    if (hiddenSelect) {
      const idx = Array.from(hiddenSelect.options).findIndex(o => o.value === variantId);
      if (idx !== -1) {
        hiddenSelect.selectedIndex = idx;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    updateStickyState(this.options[this.selectedIndex]);
  });

  const mainAtcBtn = document.querySelector(CONFIG.mainAtcBtn);
  if (mainAtcBtn) {
    new IntersectionObserver(
      ([entry]) => showBar(!entry.isIntersecting),
      { threshold: 0 }
    ).observe(mainAtcBtn);
  } else {
    window.addEventListener('scroll', () => showBar(window.scrollY > 400), { passive: true });
  }

  // 加入购物车
  stickyBtn?.addEventListener('click', function () {
    const variantId = stickySelect.value;
    if (!variantId || variantId === 'not-selected' || this.disabled) return;

    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(() => {
        this.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true, detail: { cart }
            }));
          });
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 800);
        // 调取侧边购物车弹框
        window.SLIDECART_UPDATE(function () {   window.SLIDECART_OPEN(); });
      })
      .catch(() => {
        this.textContent = 'Error – Retry';
        this.disabled = false;
      });
  });

  const initVal = variantSelection?.getAttribute('variant') || document.querySelector('select[name="id"]')?.value;
  if (initVal && initVal !== 'not-selected') {
    stickySelect.value  = initVal;
    lastStickyVariantId = initVal;
  }
  const productData = getProductJSON();
  if (productData?.variants?.length === 1) {
    const t = productData.variants[0].public_title;
    if (!t || t === 'Default Title') {
      stickySelect.style.display = 'none';
    }
  }
  updateStickyState(stickySelect.options[stickySelect.selectedIndex]);
})();
